export class PasswordFormModel {
  public password: string;
  public passwordConfirm: string;
}

export class PasswordModel {
  public currentBookingOptions: any = null; // current data of widget
  public widgetIdForRouting: string = null; // widget id

  constructor(currentBookingOptions: any, widgetIdForRouting: string) {
    this.currentBookingOptions = currentBookingOptions;
    this.widgetIdForRouting = widgetIdForRouting;
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/password-create/password-create.model.ts